import React, { useEffect, useState } from 'react';
import './adBanners.scss';

const BANNERS_API_URL =
  'https://lmicdn.blob.core.windows.net/common/banners/side_ads.json';

// Custom hook to fetch banner data
const useBannersData = () => {
  const [bannersData, setBannersData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        setIsLoading(true);
        setError(null);

        const response = await fetch(BANNERS_API_URL);

        const data = await response.json();
        const filteredAds = data.advertisements.filter((ad) => {
          const appliedApps = ad.applied_apps;
          return (
            (appliedApps && appliedApps.includes('all')) ||
            (appliedApps && appliedApps.includes('claimsComparison'))
          );
        });
        setBannersData(filteredAds);
      } catch (err) {
        setError(err.message);
        // Fallback to local banners if API fails
        setBannersData([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchBanners();
  }, []);

  return { bannersData, isLoading, error };
};

const AdBanners = () => {
  const { bannersData, isLoading, error } = useBannersData();
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (bannersData.length === 0) {
      return undefined;
    }

    const handle = window.setInterval(() => {
      setCurrentIndex((currentIndex + 1) % bannersData.length);
    }, 10000);

    return () => {
      window.clearInterval(handle);
    };
  }, [bannersData.length, currentIndex]);

  // Don't render if loading and no fallback data
  if (isLoading && bannersData.length === 0) {
    return null;
  }

  // Don't render if there's an error and no fallback data
  if (error && bannersData.length === 0) {
    return null;
  }

  const currentAd = bannersData[currentIndex];

  // Handle both new API structure and legacy local structure
  const leftImage =
    currentAd.leftImage || (currentAd.images && currentAd.images.left);
  const rightImage =
    currentAd.rightImage || (currentAd.images && currentAd.images.right);
  const leftUrl = currentAd.url || (currentAd.href && currentAd.href.left);
  const rightUrl = currentAd.url || (currentAd.href && currentAd.href.right);

  return (
    <>
      <aside className="ad-left">
        <a href={leftUrl} target="_blank" rel="noopener noreferrer">
          <img src={leftImage} alt="" />
        </a>
      </aside>
      <aside className="ad-right">
        <a href={rightUrl} target="_blank" rel="noopener noreferrer">
          <img src={rightImage} alt="" />
        </a>
      </aside>
    </>
  );
};

export default AdBanners;
